export default __webpack_public_path__ + "assets/images/storage365_object_defaultplacementimage_list_3shsf.jpg";